import { useEffect, useState } from "react";
import { onSelectionChanged, type SelectionPayload } from "../lib/office";

export function useSelection() {
  const [selection, setSelection] = useState<SelectionPayload | null>(null);
  useEffect(() => onSelectionChanged(setSelection), []);
  return selection;
}
